import { useGetTranslationsQuery } from '@api/index';
import { DataLoadingProgress } from '@components/common';
import { Alert } from '@mui/material';
import { getCurrentLanguage } from '@utils/language.utils';
import { ReactNode } from 'react';

export type TranslationLoaderProps = {
  children?: ReactNode;
};

/**
 * Translation Loader
 */
export const TranslationLoader = ({ children }: TranslationLoaderProps) => {
  const { isLoading, isSuccess, isError } = useGetTranslationsQuery({
    keys: ['Berema.Abstractions.Localization'],
    lang: getCurrentLanguage(),
  });
  return (
    <>
      {isLoading && <DataLoadingProgress />}
      {isSuccess && children}
      {isError && <Alert severity='error'>Something went wrong</Alert>}
    </>
  );
};
